// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "assets/chunk." + {"1620":"75af3195c918f77b05e7","8278":"13d5a019874d7c825800"}[chunkId] + ".css";
};